export default {
      id: "battery-report-usage",
      viewBox: "0 0 54 27",
      url: __webpack_public_path__ + "img/icons.svg#battery-report",
      toString: function () {
        return this.url;
      }
    }